var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockSharpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 .5A4.5 4.5 0 0112.5 5v1.5h.167c.736 0 1.333.597 1.333 1.333v6.334c0 .736-.597 1.333-1.333 1.333H3.333A1.334 1.334 0 012 14.166V7.833C2 7.097 2.597 6.5 3.333 6.5H3.5V5A4.5 4.5 0 018 .5zM5.5 10L7 11.5v2l.999 1L9 13.5v-2l1.5-1.5L8 7.5 5.5 10zM8 2.5A2.5 2.5 0 005.5 5v1.5h5V5A2.5 2.5 0 008 2.5z",
    fill: "#9A9CAC"
  })));
}

export default SvgLockSharpIcon;